module.exports = __webpack_public_path__ + "img/85.df4ad437.jpg";